import { Box, ButtonBase, CircularProgress, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import React, { forwardRef, useState } from "react";
import { sendInviteModalStyles } from "./styles";
import EmailIcon from "@mui/icons-material/Email";
import DeleteIcon from "@mui/icons-material/Delete";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { sendInvite } from "../../services/sendInviteService";
import { toast } from "react-toastify";
import { SendInviteResponse } from "../../proto/api_pb";
import CloseIcon from "@mui/icons-material/Close";
import { SendInviteModalProps } from "./types";
import Mixpanel from "../../utils/mixpanel";
import { APP_BACKGROUND_COLOR } from "../../theme";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const SendInviteModal: React.FC<SendInviteModalProps> = ({
  isSendInviteModalOpen,
  setIsSendInviteModalOpen,
  userId,
}) => {
  const [email, setEmail] = useState<string>("");
  const [listOfMails, setListOfMails] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { getValidAccessToken } = useGetValidAccessToken();

  const handleAddEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      setListOfMails([...listOfMails, email]);
      setEmail("");
    } else {
      toast.warning("Invalid email address");
    }
  };

  const handleDeleteEmail = (email: string) => {
    const newList = listOfMails.filter((el) => el !== email);
    setListOfMails(newList);
  };

  const handleSendInvite = async () => {
    setLoading(true);
    const accessToken = await getValidAccessToken();
    const response = await sendInvite(accessToken, listOfMails, userId);
    if (response instanceof SendInviteResponse) {
      setIsSendInviteModalOpen(false);
      setLoading(false);
      Mixpanel.track("invite_friends_success", { count: listOfMails.length });
      toast.success("Invited successfully");
    } else {
      setLoading(false);
      Mixpanel.track("invite_friends_failure");
      toast.error("Error while inviting");
    }
  };

  return (
    <>
      <Dialog
        open={isSendInviteModalOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setIsSendInviteModalOpen(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <Box
          sx={{
            backgroundColor: APP_BACKGROUND_COLOR,
            border: "1px solid gray",
          }}
        >
          <Box sx={{ display: "flex" }}>
            <DialogTitle sx={{ textAlign: "center", width: "90%" }}>
              Invite Friends to OmMuse
            </DialogTitle>
            <ButtonBase onClick={() => setIsSendInviteModalOpen(false)}>
              <CloseIcon />
            </ButtonBase>
          </Box>
          <DialogContent>
            <Box>
              {listOfMails.length > 0 &&
                listOfMails.map((el, i) => {
                  return (
                    <Box style={sendInviteModalStyles.emailContainer} key={i}>
                      <Box>
                        <EmailIcon
                          sx={{ marginRight: "10px", padding: "2px" }}
                        />
                        {el}
                      </Box>
                      <ButtonBase onClick={() => handleDeleteEmail(el)}>
                        <DeleteIcon />
                      </ButtonBase>
                    </Box>
                  );
                })}
            </Box>
            <Box sx={sendInviteModalStyles.AddEmailContainer}>
              <TextField
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                id="outlined-basic"
                label="Email"
                variant="outlined"
                type="email"
                sx={{ margin: "20px 10px" }}
              />
              <Button
                onClick={handleAddEmail}
                sx={sendInviteModalStyles.button}
                disabled={email === ""}
              >
                Add
              </Button>
            </Box>
            <Box sx={sendInviteModalStyles.sendInviteButtonContainer}>
              <Button
                disabled={loading || listOfMails.length === 0}
                sx={{ ...sendInviteModalStyles.button, ...{ width: "100%" } }}
                onClick={handleSendInvite}
              >
                {loading ? (
                  <CircularProgress sx={{ color: "black" }} />
                ) : (
                  "Send Invites"
                )}
              </Button>
            </Box>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};
